<template>
  <edi-dropdown-modal class="antiquity-info">
    <div class="info-header">
      <p class="info-title">Antigüedad como socio</p>
    </div>

    <ul class="info-list">
      <edi-partner-antiquity-chip
        text="Menos de un año"
        class="newpartner"
        :class="partnerAge === 'newpartner' ? 'active' : null"/>

      <edi-partner-antiquity-chip
        text="1 - 2 años"
        class="bronzepartner"
        :class="partnerAge === 'bronzepartner' ? 'active' : null"/>

      <edi-partner-antiquity-chip
        text="3 - 5 años"
        class="silverpartner"
        :class="partnerAge === 'silverpartner' ? 'active' : null"/>

      <edi-partner-antiquity-chip
        text="Más de 5 años"
        class="goldpartner"
        :class="partnerAge === 'goldpartner' ? 'active' : null"/>
    </ul>

    <div class="become-partner" v-if="!isPartner">
      <a :href="partnerUrl" @click.stop="$event.stopImmediatePropagation()">Hazte socio ya</a>
    </div>

    <div class="info-footer">
      <edi-close-icon/>
    </div>
  </edi-dropdown-modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import EdiPartnerAntiquityChip from '../partner/EdiPartnerAntiquityChip';

  import { EdiCloseIcon, EdiDropdownModal } from '../../../components';

  export default {
    components: {
      EdiPartnerAntiquityChip,
      EdiCloseIcon,
      EdiDropdownModal
    },
    props: {
      age: Number,
      partnerAge: String
    },
    computed: {
      ...mapGetters([
        'isPartner',
        'partnerUrl'
      ])
    }
  }
</script>